export class AdminTaskUpdate {
    taskId: string;
    isActive: boolean;
    duration: number;

    constructor(taskId: string, isActive: boolean, duration: number) {
        this.taskId = taskId;
        this.isActive = isActive;
        this.duration = duration;

    }
}
